var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { compose } from '@ally/utilitarian';
import { defaultConfigs } from './defaults';
import { parse, scrubber, serialize, excludesUrls, filtersDomains, filtersMethods, excludesMimeTypes, } from './utils';
export * from './types';
export * from './utils';
export * from './defaults';
/**
 * Given some filtering/sanitization options, will return functions that can
 * be used to scrub request and response objects before being passed to services
 * like LogRocket.
 *
 * The input data for each sanitizer follows the standard LogRocket format, but
 * this can be massaged for other purposes by wrapping the functions externally.
 *
 * @example
 * import masquerade from '@ally/masquerade'
 * const { requestSanitizer, responseSanitizer } = masquerade({ ... })
 *
 * const sanitizedReq = requestSanitizer({
 *    url: 'example'
 *    body: '{"foo":"bar"}',
 *    method: 'GET',
 *    headers: {},
 * })
 */
export default function Masquerade(options) {
    if (options === void 0) { options = {}; }
    var config = __assign(__assign({}, defaultConfigs), options);
    var scrubNetworkDataBody = function (x) { return (__assign(__assign({}, x), { body: scrubber(config)(x.body) })); };
    var scrub = compose(serialize, scrubNetworkDataBody, parse);
    // Exclusions: Functions that omit LR recording under
    // specific criteria
    var excludeUrl = excludesUrls(config);
    var excludeMimeTypes = excludesMimeTypes(config);
    // Filters: Functions that prevent scrubbing under
    // specific criteria
    var filterGET = filtersMethods(['GET']);
    var filterDOM = filtersDomains(config);
    var requestSanitizer = compose(filterDOM, filterGET, excludeMimeTypes, excludeUrl)(scrub);
    var responseSanitizer = compose(filterDOM, excludeMimeTypes, excludeUrl)(scrub);
    return {
        requestSanitizer: requestSanitizer,
        responseSanitizer: responseSanitizer,
    };
}
//# sourceMappingURL=index.js.map